// src/components/Top3Card.tsx
import React from 'react';
import { AlertCircle } from 'lucide-react';

interface Top3CardProps {
  predictions: Array<{
    family: string;
    confidence: number;
    threat_level: string;
  }>;
  threatLevel: string;
}

const Top3Card: React.FC<Top3CardProps> = ({ predictions, threatLevel }) => {
  const isClean = threatLevel === 'CLEAN';

  const getColor = (level: string) => {
    if (isClean) return '#6b6b80'; // grey out threat colors for clean files
    switch (level) {
      case 'CRITICAL': return '#ef4444';
      case 'HIGH':     return '#f97316';
      case 'MEDIUM':   return '#eab308';
      default:         return '#22c55e';
    }
  };

  return (
    <div className="info-card">
      <h3 className="card-title">Top 3 Candidates</h3>

      {/* Disclaimer for clean files */}
      {isClean && (
        <div className="top3-disclaimer">
          <AlertCircle size={13} />
          <span>
            VirusTotal found no threats. These are CNN pattern matches only
            and do not indicate malicious activity.
          </span>
        </div>
      )}

      <div className="top3-list">
        {predictions.map((pred, idx) => (
          <div key={idx} className={`top3-item ${isClean ? 'top3-item-muted' : ''}`}>
            <div className="top3-header">
              <div className="top3-rank">
                <span className={`rank-badge rank-${idx + 1}`}>#{idx + 1}</span>
                <span className="top3-family">{pred.family}</span>
              </div>
              <span
                className="threat-badge-small"
                style={{ backgroundColor: getColor(pred.threat_level) }}
              >
                {pred.threat_level}
              </span>
            </div>
            <div className="confidence-bar-container">
              <div
                className="confidence-fill-bar"
                style={{
                  width: `${pred.confidence * 100}%`,
                  backgroundColor: getColor(pred.threat_level)
                }}
              />
            </div>
            <div className="confidence-percent">
              {(pred.confidence * 100).toFixed(1)}%
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Top3Card;
